export default __webpack_public_path__ + "static/media/season_autumn.d08e0385.webp";